/**
 * Extrai o ID numérico de parâmetros de rota, ignorando sufixos legados
 * (ex.: `1?kind=pessoa` codificado no segmento).
 */
export function parseRouteNumericId(value: string | null | undefined): number {
  if (!value) {
    return 0;
  }

  const normalized = decodeURIComponent(value).split('?')[0]?.trim() ?? '';
  const id = Number(normalized);

  return Number.isFinite(id) && id > 0 ? id : 0;
}
